export enum IdentityDocumentType {
  IdentityCard = 0,
  Passport = 1,
}
